
import { Component, Prop, Mixins } from 'vue-property-decorator';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { AppModule } from '@/store/modules/app';
import { EVENTS } from '@/author/constants';
import { generateHash } from '@/author/components/helper/hash';
import FocusTrap from '@/mixins/FocusTrap';
import ModalStackChildren from '@/mixins/ModalStackChildren';


const AppState = getModule(AppModule, store);

@Component
export default class Modal extends Mixins(FocusTrap, ModalStackChildren) {
  @Prop(Boolean) fullLocked?: boolean;
  @Prop(Boolean) completionByInnerComponent!: boolean;
  @Prop() image!: string;
  @Prop() alt!: string;
  @Prop() imageCompleted!: string;
  @Prop() altCompleted!: string;
  @Prop() video!: string;
  @Prop() vtt!: string;
  @Prop() imageModal!: string;
  @Prop() altImageModal!: string;
  @Prop() title!: string;
  @Prop() subtitle!: string;
  @Prop() hiddenModalTitle?: string;
  @Prop() ariaLabeledby?: string;
  @Prop() ariaDescribedby?: string;
  @Prop() size!: string;
  @Prop() theme?: string;
  @Prop() videoBackgroundTheme?: string;
  @Prop() customClass?:String;
  @Prop() disableAutoplay?: boolean;
  @Prop({ default: false }) videoHideCaptionsButton!: boolean;
  @Prop() videoShowCaptionsByDefault?: boolean;
  active: boolean = false;
  bodyFeedbackClass: string = ' showing-modal';
  highlighted: boolean = false;
  foncusOnTextCaught: boolean = false;

  public $refs!: {
    modal: HTMLElement;
    trigerrer: HTMLElement;
    closeButtonRef: HTMLElement;
  };

  created() {
    this.$parent?.$on('setup-modal', (hash: number) => {
      if (this.hash === hash) this.completed = true;
    });
    this.$on(EVENTS.COMPLETED, this.setVideoCompleted);
    this.$on(EVENTS.REFRESHED, this.innerComponentRefreshed);
  }

  //TODO: refreshing was only implemented for the modal to update itself and retrap focus.
  // If the trap implementation is better handled, we won't need this logic anymore
  innerComponentRefreshed(){
    this.trapFocus(true);
  }

  setVideoCompleted(){
    this.highlighted = true;
    this.trapFocus(true);
    if (this.getCompleteByInnerComponent()) this.completed = true;
  }

  public setActive() {
    if (this.video) 
      setTimeout(() => {
        this.$refs.closeButtonRef?.focus();
      }, 1000);
    
    if (this.isTheNextModalAvailable()) {
      this.setIsActive(true);
      this.trapFocus(true);

      if (!this.getCompleteByInnerComponent()) this.completed = true;
      if (!this.video) 
        setTimeout(() => {
          this.highlighted = true;
        }, 5000);
    }
  }

  public setIsActive(active: boolean) {
    let main = document.getElementById('MainContainer');
    this.active = active;
    this.foncusOnTextCaught = false;
    if (active) {
      document.body.className += this.bodyFeedbackClass;
      if(main)
        main.setAttribute('aria-hidden', 'true');
    } else {
      this.$refs.trigerrer.focus();
      setTimeout(()=>{
        if(main)
          main.setAttribute('aria-hidden', 'false');
        this.$refs.trigerrer.focus();
      },100);
    }
  }

  public isCompleted(): boolean {
    return this.completed;
  }

  public close(e?: Event) {
    if (e) e.preventDefault();
    this.active = false;
    this.setIsActive(false);
    if (!this.getCompleteByInnerComponent() || this.imageModal !== undefined)
      this.completed = true;

    if (this.isCompleted()) {
      this.$parent?.$emit(EVENTS.COMPLETED, this.hash);
      this.$emit('modalcompleted');
    }
    document.body.className = document.body.className.replace(
      new RegExp(this.bodyFeedbackClass, 'g'),
      ''
    );
  }

  get hash(): number {
    let innerHtml = this.$refs.modal ? this.$refs.modal.innerHTML : '';
    return generateHash(
      this.title +
        this.subtitle +
        this.image +
        this.video +
        this.imageModal +
        this.getCompleteByInnerComponent() +
        this.alt +
        this.altImageModal+
        innerHtml
    );
  }


  onEscDown() {
    // If we're in fullscreen mode, we can let esc cancel
    // fullscreen mode and not let it close the modal just yet
    if (!AppState.getIsFullscreen) 
      this.close();
  }

  public getCompleteByInnerComponent(){
    return this.fullLocked || this.completionByInnerComponent;
  }

  get hiddenTitle(){
    if(this.ariaLabeledby || this.ariaDescribedby) return null;
    return this.hiddenModalTitle || this.title || this.subtitle || '';
  }
}
